import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createGiftCardProductRequest = { giftCardProduct: '_giftCardProduct' };
var _createGiftCardProductResponse = { giftCardProduct: '_giftCardProduct' };
var _deleteGiftCardProductRequest = {};
var _deleteGiftCardProductResponse = {};
var _getGiftCardProductRequest = {};
var _getGiftCardProductResponse = { giftCardProduct: '_giftCardProduct' };
var _giftCardProduct = {
    fixedExpirationDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryGiftCardProductsRequest = {};
var _queryGiftCardProductsResponse = { giftCardProducts: '_giftCardProduct' };
var _updateGiftCardProductRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    giftCardProduct: '_giftCardProduct',
};
var _updateGiftCardProductResponse = { giftCardProduct: '_giftCardProduct' };
function resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/gift-card-product',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        _: [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/gift-cards/v1/gift-card-products',
                destPath: '/v1/gift-card-products',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new gift card product. */
export function createGiftCardProduct(payload) {
    var _a = serializer(_createGiftCardProductRequest, { _giftCardProduct: _giftCardProduct }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGiftCardProductResponse, {
        _giftCardProduct: _giftCardProduct,
    }).fromJSON;
    function __createGiftCardProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gift_cards.v1.gift_card_product',
            method: 'POST',
            methodFqn: 'wix.gift_cards.gift_card_product.v1.GiftCardProductService.CreateGiftCardProduct',
            url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                protoPath: '/v1/gift-card-products',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGiftCardProduct.fromReq = fromReq;
    __createGiftCardProduct.__isAmbassador = true;
    return __createGiftCardProduct;
}
/** Retrieves a gift card product. */
export function getGiftCardProduct(payload) {
    var _a = serializer(_getGiftCardProductRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGiftCardProductResponse, {
        _giftCardProduct: _giftCardProduct,
    }).fromJSON;
    function __getGiftCardProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gift_cards.v1.gift_card_product',
            method: 'GET',
            methodFqn: 'wix.gift_cards.gift_card_product.v1.GiftCardProductService.GetGiftCardProduct',
            url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                protoPath: '/v1/gift-card-products/{giftCardProductId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGiftCardProduct.fromReq = fromReq;
    __getGiftCardProduct.__isAmbassador = true;
    return __getGiftCardProduct;
}
/**
 * Updates a gift card product.
 * Supports partial update.
 * Pass the latest `revision` for a successful update.
 * Each time the category is updated, `revision` increments by 1.
 */
export function updateGiftCardProduct(payload) {
    var _a = serializer(_updateGiftCardProductRequest, { _giftCardProduct: _giftCardProduct }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGiftCardProductResponse, {
        _giftCardProduct: _giftCardProduct,
    }).fromJSON;
    function __updateGiftCardProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gift_cards.v1.gift_card_product',
            method: 'PATCH',
            methodFqn: 'wix.gift_cards.gift_card_product.v1.GiftCardProductService.UpdateGiftCardProduct',
            url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                protoPath: '/v1/gift-card-products/{giftCardProduct.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGiftCardProduct.fromReq = fromReq;
    __updateGiftCardProduct.__isAmbassador = true;
    return __updateGiftCardProduct;
}
/** Deletes a gift card product. */
export function deleteGiftCardProduct(payload) {
    var _a = serializer(_deleteGiftCardProductRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteGiftCardProductResponse, {}).fromJSON;
    function __deleteGiftCardProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gift_cards.v1.gift_card_product',
            method: 'DELETE',
            methodFqn: 'wix.gift_cards.gift_card_product.v1.GiftCardProductService.DeleteGiftCardProduct',
            url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                protoPath: '/v1/gift-card-products/{giftCardProductId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteGiftCardProduct.fromReq = fromReq;
    __deleteGiftCardProduct.__isAmbassador = true;
    return __deleteGiftCardProduct;
}
/**
 * Retrieves a list of gift card products, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 gift card products can be returned per request.
 *
 * To learn how to query gift card products, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryGiftCardProducts(payload) {
    var _a = serializer(_queryGiftCardProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGiftCardProductsResponse, {
        _giftCardProduct: _giftCardProduct,
    }).fromJSON;
    function __queryGiftCardProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gift_cards.v1.gift_card_product',
            method: 'GET',
            methodFqn: 'wix.gift_cards.gift_card_product.v1.GiftCardProductService.QueryGiftCardProducts',
            url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                protoPath: '/v1/gift-card-products/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixGiftCardsGiftCardProductV1GiftCardProductServiceUrl({
                        protoPath: '/v1/gift-card-products/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryGiftCardProducts.fromReq = fromReq;
    __queryGiftCardProducts.__isAmbassador = true;
    return __queryGiftCardProducts;
}
//# sourceMappingURL=http.impl.js.map